import "bootstrap/dist/css/bootstrap.css";
import "bootstrap";

import {
  Matrix,
  inverse,
  solve,
  linearDependencies,
  QrDecomposition,
  LuDecomposition,
  CholeskyDecomposition,
  EigenvalueDecomposition,
} from "ml-matrix";


import {
  createTableFromArray,
  createTableFromArrayWithHeading,
} from "./utils/utility";

// import test statistika
var { jStat, default: jstat, ones, transpose } = require("jstat");
var stats = require("statistics2");

import DatiPravci from "./class/optimizacija_2d_duzine";
import DateKoordinate from "./class/2d_koordtacke";
import DateDuzine from "./class/optimizacija_2d_pravci";
import DateFigure from "./class/optimizacija_2d_figura";
import DatiGNSSVektor from "./class/DatiGNSSVektor";

import {
  NiAnaB,
  dAB,
  koeficijenti_pravca_ab,
  koeficijenti_duzine_AB,
} from "./utils/geodezija";

matTacaka = [];
matPravaca = [];
matDuzina = [];
matFigura = [];
matGNSSVektor = [];

btnCloseModal.addEventListener("click", function () {
  closeMessage();
});

btnOptimizacija.addEventListener("click", function () {
  //sada prvo da ispraznimo sve
  matTacaka = [];
  matPravaca = [];
  matDuzina = [];
  document.getElementById("izlaz").innerHTML = "";
  document.getElementById("zaIzvestaj").innerHTML = "";
  parsirajUlaznePodatke();
  Optimizacije_2D_Mreze();
});



function parsirajUlaznePodatke() {
  //parsiranje ulaznih podataka

  //parsiraj koordinate
  let listaTacaka = document.getElementById("lstPriblizneKoordinate").value;
  let lRepera = listaTacaka.split("\n");
  lRepera.forEach((element) => {
    let a;
    document.getElementById("flexRadioD").checked
      ? (a = element.split(","))
      : (a = element.split("\t"));
    let g;
    if (a.length == 3) {
      g = new DateKoordinate(
        a[0].replace(/\s/g, ""),
        parseFloat(a[1].replace(/\s/g, "")),
        parseFloat(a[2].replace(/\s/g, ""))
      );
      //g = new Reper(a[0].replace(/\s/g, ""), a[1].replace(/\s/g, ""), a[2].replace(/\s/g, ""));
      matTacaka.push(g);
    }
  });
}

function parsirajKoordiante() {
  //parsiraj koordinate
  let listaTacaka = document.getElementById("lstPriblizneKoordinate").value;
  let lRepera = listaTacaka.split("\n");
  let brojac = 0;
  lRepera.forEach((element) => {
    let a;
    document.getElementById("flexRadioD").checked
      ? (a = element.split(","))
      : (a = element.split("\t"));
    let g;
    if (a.length == 4) {
      g = new DateKoordinate(
        a[0].replace(/\s/g, ""),
        parseFloat(a[1].replace(/\s/g, "")),
        parseFloat(a[2].replace(/\s/g, "")),
        parseInt(a[3].replace(/\s/g, "")),
        brojac
      );
      matTacaka.push(g);
      brojac += 1;
    }
  });
}


//matrica A treba da izgleda
//1y,1x,2y,2x ......

function Optimizacije_2D_Mreze() {
  //idemo da formiramo matricu A
  //ona se bazira na koordinatama tacaka i ima 4 koeficijenta dva za uglove dva za duzine
  //idemo prvo da vidimo kolika je matrica A
  var mat_A = Matrix.zeros(
    matPravaca.length + matDuzina.length,
    matTacaka.length * 2
  ); // ovde je pravac+duzina! a ne samo pravac!
  var mat_P = Matrix.zeros(
    matPravaca.length + matDuzina.length,
    matPravaca.length + matDuzina.length
  );

  let st_ci = parseFloat(document.getElementById("opt_metodCentrisanja").value);
  let broj_girusa = parseInt(document.getElementById("opt_brojGirusa").value);
  let forPrint = document.getElementById("izlaz");
  let forReport = document.getElementById("zaIzvestaj");
  let div_ = document.createElement("div");
  let divIzvestaj = document.createElement("zaizv");
  divIzvestaj.style.background = random_bg_color();
  div_.style.background = random_bg_color();

  //aj sad da uradim sledece - ako ima upisanu toleranciju onda radis po tome
  //ako obrenovac nema upisanu toleranciju onda idemo da proverimo stanadrd ugla u duzine

  isNaN(parseInt(document.getElementById("txt_Tolerancija").value))
    ? (Tolerancija = 0)
    : (Tolerancija = parseInt(
        document.getElementById("txt_Tolerancija").value
      ));

  //ovo mora drugaije jer ima , (kod parsiranja)
  let srg_duzine_par = document
    .getElementById("txt_srednjagreskaduzine")
    .value.split(",");
  let srg_duzine_apriori = parseInt(
    document.getElementById("txt_srednjagreskaduzine_apriori").value
  );
  let srg_ugla = parseInt(
    document.getElementById("txt_srednjagreskaugla").value
  ); // ovde moze da ima dve velicine 2+2/km i 2
  let srg_ugla_apriori = parseInt(
    document.getElementById("txt_srednjagreskaugla").value
  ); // ovde moze da ima dve velicine 2+2/km i 2

  let sigma_polozaja;
  let sigma_objekta;
  let sigma_datihVelicina;
  let sigma_mreze;
  let delta;
  if (Tolerancija != 0) {
    delta = Tolerancija / Math.sqrt(2);
    sigma_polozaja = delta / 3;
    sigma_objekta = delta / 3;
    sigma_datihVelicina = delta / 9;
    sigma_mreze = sigma_objekta / 3;
    let izv_ = [
      [
        "Tolerancija",
        String.fromCharCode(963) + " polozaja",
        String.fromCharCode(963) + " objekta",
        String.fromCharCode(963) + " dv",
        String.fromCharCode(963) + " mreze",
      ],
      [
        Tolerancija,
        sigma_polozaja,
        sigma_objekta,
        sigma_datihVelicina,
        sigma_mreze,
      ],
    ];
    createTableFromArray(izv_, "standardi", divIzvestaj, 5);
  }

  let ro_ = (180 / Math.PI) * 3600;

  //sada idemo da za svaku tacku pronademo gde je
  //znaci tebi treba po pravcima da ides
  var i, j;

  //PRAVCI
  let naslov = [["od", "do", "ni", "d"]];
  for (i = 0; i < matPravaca.length; i++) {
    //sada idemo na prvi pravac
    od_ = matPravaca[i].odtacke;
    do_ = matPravaca[i].dotacke;
    //sada ti trebaju koordinate
    var x1, y1, x2, y2;
    var index_prva, index_druga;

    for (j = 0; j < matTacaka.length; j++) {
      if (matTacaka[j].brtacke == od_) {
        index_prva = j;
        x1 = matTacaka[j].x;
        y1 = matTacaka[j].y;
        break;
      }
    }
    for (j = 0; j < matTacaka.length; j++) {
      if (matTacaka[j].brtacke == do_) {
        index_druga = j;
        x2 = matTacaka[j].x;
        y2 = matTacaka[j].y;
        break;
      }
    }
    //sada mozes na koeficijente i da ih smestis u matricu
    var ni = NiAnaB(y1, x1, y2, x2);
    var d = dAB(y1, x1, y2, x2);
    var koef_ = koeficijenti_pravca_ab(ni, d);
    //sada ide u matricu!
    mat_A.set(i, index_prva * 2, koef_[1]);
    mat_A.set(i, index_prva * 2 + 1, koef_[0]);
    mat_A.set(i, index_druga * 2, -koef_[1]);
    mat_A.set(i, index_druga * 2 + 1, -koef_[0]);

    Tolerancija != 0
      ? mat_P.set(i, i, 1 / ((sigma_polozaja / (d * 1000)) * ro_) ** 2)
      : mat_P.set(i, i, srg_ugla_apriori ** 2 / srg_ugla ** 2);
    naslov.push([od_, do_, ni, d]);
  }
  //dodas u izvestaj
  createTableFromArray(naslov, "PRAVCI - ni, d", div_, 5);
  //DUZINE
  naslov = [["od_", "do_", "ni", "d"]];
  for (i = 0; i < matDuzina.length; i++) {
    od_ = matDuzina[i].odtacke;
    do_ = matDuzina[i].dotacke;
    var x1, y1, x2, y2;
    var index_prva, index_druga;

    for (j = 0; j < matTacaka.length; j++) {
      if (matTacaka[j].brtacke == od_) {
        index_prva = j;
        x1 = matTacaka[j].x;
        y1 = matTacaka[j].y;
        break;
      }
    }
    for (j = 0; j < matTacaka.length; j++) {
      if (matTacaka[j].brtacke == do_) {
        index_druga = j;
        x2 = matTacaka[j].x;
        y2 = matTacaka[j].y;
        break;
      }
    }

    var ni = NiAnaB(y1, x1, y2, x2);
    var d = dAB(y1, x1, y2, x2);
    var koef_ = koeficijenti_duzine_AB(ni);
    //sada ide u matricu!
    mat_A.set(i + matPravaca.length, index_prva * 2, koef_[1]);
    mat_A.set(i + matPravaca.length, index_prva * 2 + 1, koef_[0]);
    mat_A.set(i + matPravaca.length, index_druga * 2, -koef_[1]);
    mat_A.set(i + matPravaca.length, index_druga * 2 + 1, -koef_[0]);
    //ovde mozes da imas mogucnost da je 2+2/km ili 2ppk

    if (Tolerancija != 0) {
      mat_P.set(
        i + matPravaca.length,
        i + matPravaca.length,
        1 / sigma_polozaja ** 2
      );
    } else {
      srg_duzine_par.length == 0
        ? (srg_duzine = (d / 1000) * parseFloat(srg_duzine_par[0]))
        : (srg_duzine =
            parseFloat(srg_duzine_par[0]) +
            (d / 1000) * parseFloat(srg_duzine_par[1])); //ovde se sve dobija u milimetar/km
      mat_P.set(
        i + matPravaca.length,
        i + matPravaca.length,
        srg_duzine_apriori ** 2 / srg_duzine ** 2
      );
    }
    naslov.push([od_, do_, ni, d]);
  }
  //dodas u izvestaj
  createTableFromArray(naslov, "PRAVCI - ni, d", div_, 5);

  createTableFromArray(mat_A.to2DArray(), "Matrica A", div_, 5);
  createTableFromArray(mat_P.to2DArray(), "Matrica P", div_, 5);

  let mat_R = new Matrix(3, matTacaka.length * 2);

  //racunas g
  let x_nad = 0;
  y_nad = 0;

  //racunanje aritmeticke sredine
  for (i = 0; i < matTacaka.length; i++) {
    x_nad = x_nad + matTacaka[i].x;
    y_nad = y_nad + matTacaka[i].y;
  }
  x_nad = x_nad / matTacaka.length;
  y_nad = y_nad / matTacaka.length;

  let x_nad_t = 0,
    y_nad_t = 0;

  //racunanje G
  for (i = 0; i < matTacaka.length; i++) {
    x_nad_t = x_nad - matTacaka[i].x;
    y_nad_t = y_nad - matTacaka[i].y;
  }
  let g = Math.sqrt(x_nad_t ** 2 + y_nad_t ** 2 + matTacaka.length * ro_);

  //sada mozes da je formiras matricu R - matricu prosirenja
  for (i = 0; i < matTacaka.length; i++) {
    mat_R.set(0, i * 2, 1 / Math.sqrt(matTacaka.length));
    mat_R.set(0, i * 2 + 1, 0);
    mat_R.set(1, i * 2, 0);
    mat_R.set(1, i * 2 + 1, 1 / Math.sqrt(matTacaka.length));
    let g = Math.sqrt(x_nad_t ** 2 + y_nad_t ** 2 + matTacaka.length * ro_);
    mat_R.set(2, i * 2, -(matTacaka[i].x - x_nad) / g);
    mat_R.set(2, i * 2 + 1, (matTacaka[i].y - y_nad) / g);
  }

  //sta je ovde problem!
  let mat_AT = mat_A.transpose();
  let mat_N = mat_AT.mmul(mat_P).mmul(mat_A);
  createTableFromArray(
    mat_N.to2DArray(),
    "Matrica N (matrica Normalnih jednačina)",
    div_,
    5
  );
  let mat_NP = mat_N_Prosireno(mat_N, mat_R.transpose());

  createTableFromArray(mat_NP.to2DArray(), "Matrica N prosireno", div_, 5);

  let mat_Q = inverse(mat_NP, (useSVD = true));
  let dokle_ = mat_Q.rows - 3;
  let mat_Qx = mat_Q.subMatrix(0, dokle_ - 1, 0, dokle_ - 1);

  createTableFromArray(mat_Qx.to2DArray(), "Matrica Qx", div_, 5);

  //matica koja se dobija kao (N+B*Bt)-1 - B*Bt
  let mat_q2 = mat_R.transpose().mmul(mat_R);
  let mat_q1 = mat_N.add(mat_q2);
  mat_q1 = inverse(mat_q1, (useSVD = true));
  mat_NPlus = mat_q1.sub(mat_q2);
  createTableFromArray(mat_NPlus.to2DArray(), "Matrica N+", div_, 5);

  //sada mozemo da sracunamo standardna odstupanja polozaja
  let mat_gg = [];
  mat_gg.push(["pnt", "sY[mm]", "sX[mm]", "sP[mm]"]);
  let brojac_ = 0;
  for (i = 0; i < mat_Qx.rows; i += 2) {
    let pp = [
      matTacaka[brojac_].brtacke,
      Math.sqrt(mat_Qx.get(i, i)),
      Math.sqrt(mat_Qx.get(i + 1, i + 1)),
      Math.sqrt(mat_Qx.get(i + 1, i + 1) + mat_Qx.get(i, i)),
    ];
    mat_gg.push(pp);
    brojac_ = brojac_ + 1;
  }
  createTableFromArray(
    mat_gg,
    "Srednja greska po po osi i poloazaja",
    divIzvestaj,
    5
  );

  let mat_Ql = mat_A.mmul(mat_Qx).mmul(mat_AT);
  createTableFromArray(mat_Ql.to2DArray(), "Matrica Ql", div_, 5);

  let mat_Qv = inverse(mat_P).sub(mat_Ql);
  createTableFromArray(mat_Qv.to2DArray(), "Matrica Qv", div_, 5);

  let R = mat_P.mmul(mat_Qv);
  createTableFromArray(R.to2DArray(), "Matrica R", div_, 5);

  //sada ti trebaju elipse gresaka
  mat_gg = [];
  mat_gg.push([
    "brt",
    "z(i)[mm]",
    "A[mm]",
    "B[mm]",
    "A[mm] 95%",
    "B[mm] 95%",
    "odnos A:B",
    "teta (rad)",
    "teta (dec)",
  ]);
  brojac_ = 0;

  //treba mi F raspored
  stat_ = Math.sqrt(
    2 * stats.pfX_(2, mat_Qv.rows - matTacaka.length * 2 + 1, 0.95)
  );

  for (i = 0; i < mat_Qx.rows; i += 2) {
    let z = Math.sqrt(
      (mat_Qx.get(i, i) - mat_Qx.get(i + 1, i + 1)) ** 2 +
        4 * mat_Qx.get(i, i + 1) ** 2
    );
    let teta =
      0.5 *
      Math.atan2(
        2 * mat_Qx.get(i, i + 1),
        mat_Qx.get(i + 1, i + 1) - mat_Qx.get(i, i)
      );
    let pp = [
      matTacaka[brojac_].brtacke,
      z,
      Math.sqrt((mat_Qx.get(i + 1, i + 1) + mat_Qx.get(i, i) + z) * 0.5),
      Math.sqrt((mat_Qx.get(i + 1, i + 1) + mat_Qx.get(i, i) - z) * 0.5),
      Math.sqrt((mat_Qx.get(i + 1, i + 1) + mat_Qx.get(i, i) + z) * 0.5) *
        stat_,
      Math.sqrt((mat_Qx.get(i + 1, i + 1) + mat_Qx.get(i, i) - z) * 0.5) *
        stat_,
      (
        Math.sqrt((mat_Qx.get(i + 1, i + 1) + mat_Qx.get(i, i) + z) * 0.5) /
        Math.sqrt((mat_Qx.get(i + 1, i + 1) + mat_Qx.get(i, i) - z) * 0.5)
      ).toFixed(2),
      teta,
      teta < 0 ? rad2dec(teta) + 360 : rad2dec(teta),
    ];
    mat_gg.push(pp);
    brojac_ = brojac_ + 1;
  }
  createTableFromArray(mat_gg, "Elipsa gresaka", divIzvestaj, 5);

  //ovo mozes da sracunas ako je dato T
  let ulaz = prompt("Koji je standard mreze", sigma_mreze);
  sigma_mreze = parseFloat(ulaz);
  let zaPrikaz = [];
  korenlamda = 7;

  // zaPrikaz.push(["Ql", "Qv", "r", "G"]);

  //let sum_r = 0;

  // for (i = 0; i < mat_Ql.columns; i++) {
  //     let g = [mat_Ql.get(i, i), mat_Qv.get(i, i), R.get(i, i),
  //     sigma_mreze * korenlamda / Math.sqrt(mat_P.get(i, i) * mat_Qv.get(i, i))
  //     ]
  //     sum_r = sum_r + R.get(i, i)
  //     zaPrikaz.push(g)
  // }

  // createTableFromArray(zaPrikaz, "Standardi", divIzvestaj, 5);

  //zaPrikaz = [];
  zaPrikaz.push(["od", "do", "Ql", "Qv", "r", "G"]);
  sum_r = 0;

  for (i = 0; i < matPravaca.length; i++) {
    let g = [
      matPravaca[i].odtacke,
      matPravaca[i].dotacke,
      mat_Ql.get(i, i),
      mat_Qv.get(i, i),
      R.get(i, i),
      (sigma_mreze * korenlamda) /
        Math.sqrt(mat_P.get(i, i) * mat_Qv.get(i, i)),
    ];
    sum_r = sum_r + R.get(i, i);
    zaPrikaz.push(g);
  }

  createTableFromArray(zaPrikaz, "Standardi-Pravci", divIzvestaj, 5);

  zaPrikaz = [];

  zaPrikaz.push(["od", "do", "Ql", "Qv", "r", "G"]);
  sum_r = 0;

  for (i = 0; i < matDuzina.length; i++) {
    let g = [
      matDuzina[i].odtacke,
      matDuzina[i].dotacke,
      mat_Ql.get(i + matPravaca.length, i + matPravaca.length),
      mat_Qv.get(i + matPravaca.length, i + matPravaca.length),
      R.get(i + matPravaca.length, i),
      (sigma_mreze * korenlamda) /
        Math.sqrt(
          mat_P.get(i + matPravaca.length, i + matPravaca.length) *
            mat_Qv.get(i + matPravaca.length, i + matPravaca.length)
        ),
    ];
    sum_r = sum_r + R.get(i + matPravaca.length, i + matPravaca.length);
    zaPrikaz.push(g);
  }

  createTableFromArray(zaPrikaz, "Standardi-Duzine", divIzvestaj, 5);

  //sada mozemo da idemo dalje na proracune tacnosti
  let mat_paravac_ocena_Tacnosti = [];

  //PRAVCI

  if (ulaz != null) {
    sigma_mreze = parseFloat(ulaz);
  }

  mat_paravac_ocena_Tacnosti.push([
    "od",
    "do",
    String.fromCharCode(963) + " pravca",
    "Tezina",
    "Ql " + String.fromCharCode(963) + "(" + String.fromCharCode(945) + ")",
    "CS2",
    "(CI)2",
    String.fromCharCode(963) + String.fromCharCode(949) + "2sr",
    "Broj girusa",
    String.fromCharCode(963).concat(String.fromCharCode(949)),
    String.fromCharCode(963),
    String.fromCharCode(963) + "2C",
    String.fromCharCode(963) + "2Cmax-2Cmin",
    String.fromCharCode(916) + "2C",
  ]);

  for (i = 0; i < matPravaca.length; i++) {
    //sada idemo na prvi pravac
    od_ = matPravaca[i].odtacke;
    do_ = matPravaca[i].dotacke;
    //sada ti trebaju koordinate
    var x1, y1, x2, y2;
    var index_prva, index_druga;

    for (j = 0; j < matTacaka.length; j++) {
      if (matTacaka[j].brtacke == od_) {
        index_prva = j;
        x1 = matTacaka[j].x;
        y1 = matTacaka[j].y;
        break;
      }
    }
    for (j = 0; j < matTacaka.length; j++) {
      if (matTacaka[j].brtacke == do_) {
        index_druga = j;
        x2 = matTacaka[j].x;
        y2 = matTacaka[j].y;
        break;
      }
    }

    var d = dAB(y1, x1, y2, x2);
    var se2rs =
      mat_Ql.get(i, i) -
      (st_ci * ro_) ** 2 / (2 * (d * 1000) ** 2) -
      (st_ci * ro_) ** 2 / (2 * (d * 1000) ** 2);
    let gg = [
      od_, //"od"
      do_, //"do"
      (sigma_mreze / (d * 1000)) * ro_, //"sigma pravca"
      1 / ((sigma_mreze / (d * 1000)) * ro_) ** 2, //"Tezina"
      mat_Ql.get(i, i), //"sauk"
      (st_ci * ro_) ** 2 / (2 * (d * 1000) ** 2), //"(CS)2"
      (st_ci * ro_) ** 2 / (2 * (d * 1000) ** 2), // "CI2"
      se2rs, //"se2sr"
      broj_girusa, //"Broj girusa"
      Math.sqrt(se2rs * broj_girusa), //"se"
      Math.sqrt(se2rs * broj_girusa) * Math.sqrt(2), // s
      Math.sqrt(se2rs * broj_girusa) * Math.sqrt(2) * Math.sqrt(2), //s2C
      Math.sqrt(se2rs * broj_girusa) *
        Math.sqrt(2) *
        Math.sqrt(2) *
        Math.sqrt(2), //s2Cmax-2Cmin
      Math.sqrt(se2rs * broj_girusa) *
        Math.sqrt(2) *
        Math.sqrt(2) *
        Math.sqrt(2) *
        stats.pnormaldist(1 - 0.05 / 2), //D2C
    ];
    mat_paravac_ocena_Tacnosti.push(gg);
  }

  //sada ti trebaju minimalne vrednosti!

  createTableFromArrayWithHeading(
    mat_paravac_ocena_Tacnosti,
    "Ocena tacnosti - Pravci",
    divIzvestaj,
    5
  );
  min_sigma = 100000;
  suma_sigma_count = 0;
  for (i = 0; i < mat_paravac_ocena_Tacnosti.length; i++) {
    if (mat_paravac_ocena_Tacnosti[i][7] < min_sigma) {
      min_sigma = mat_paravac_ocena_Tacnosti[i][7];
      suma_sigma_count = i;
    }
  }
  //sada ces imati celu interaciju

  let minimalni_kriterijum = [];
  minimalni_kriterijum.push([
    "od",
    "do",
    String.fromCharCode(963) + " pravca",
    "Tezina",
    "Ql " + String.fromCharCode(963) + "(" + String.fromCharCode(945) + ")",
    "CS2",
    "(CI)2",
    String.fromCharCode(963) + String.fromCharCode(949) + "2sr",
    "Broj girusa",
    String.fromCharCode(963).concat(String.fromCharCode(949)),
    String.fromCharCode(963),
    String.fromCharCode(963) + "2C",
    String.fromCharCode(963) + "2Cmax-2Cmin",
    String.fromCharCode(916) + "2C",
  ]);
  minimalni_kriterijum.push(mat_paravac_ocena_Tacnosti[suma_sigma_count]);

  createTableFromArrayWithHeading(
    minimalni_kriterijum,
    "Minimalne vrednsoti za kriterijum",
    divIzvestaj,
    5
  );

  //sada treba da ide racunanje po trouglovima - dozvoljena ne zatvaranja!
  mat_figure_ocena = [];
  mat_figure_ocena.push([
    "trougao",
    String.fromCharCode(963).concat(String.fromCharCode(949)).concat("2"),
    String.fromCharCode(963).concat(String.fromCharCode(949)),
    "tp",
    String.fromCharCode(931).concat(
      String.fromCharCode(963).concat(String.fromCharCode(949)).concat("2")
    ),
    String.fromCharCode(963).concat(String.fromCharCode(916)),
    "w".concat(String.fromCharCode(916)),
  ]);
  tp = 1.96;
  matFigura.forEach((figura) => {
    console.log(figura.pravac1 + "," + figura.pravac2 + "," + figura.pravac3);
    suma_sigma = 0;
    min_sigma = 1000000000;
    suma_sigma_count = 0;
    mat_paravac_ocena_Tacnosti.forEach((ocena) => {
      if (
        (ocena[0] == figura.pravac1 ||
          ocena[0] == figura.pravac2 ||
          ocena[0] == figura.pravac3) &&
        (ocena[1] == figura.pravac1 ||
          ocena[1] == figura.pravac2 ||
          ocena[1] == figura.pravac3)
      ) {
        //znaci nasao ga je!
        //ovde bi trebalo da ide neki broj figure i epsilon!
        console.log("ispunjava uslov");
        console.log(ocena);
        if (Math.sqrt(ocena[7]) < min_sigma) {
          min_sigma = ocena[7];
        }
        suma_sigma = ocena[7] + suma_sigma;
        suma_sigma_count += 1;
        mat_figure_ocena.push([
          ocena[0] + "," + ocena[1],
          ocena[7],
          Math.sqrt(ocena[7]),
          "",
          "",
          "",
          "",
        ]);
      }
    });
    //sada mozes dalje
    let tp = 1.96; //odakle ovo?

    mat_figure_ocena.push([
      figura.pravac1 + "," + figura.pravac2 + "," + figura.pravac3,
      "",
      "",
      tp,
      suma_sigma,
      Math.sqrt(suma_sigma),
      Math.sqrt(suma_sigma) * tp,
    ]);
  });

  createTableFromArrayWithHeading(
    mat_figure_ocena,
    "Ocena po trouglovima",
    divIzvestaj,
    5
  );

  forPrint.append(div_);
  forReport.append(divIzvestaj);
  alert("Kraj");
}

function random_bg_color() {
  var x = Math.floor(Math.random() * 256);
  var y = Math.floor(Math.random() * 256);
  var z = Math.floor(Math.random() * 256);
  return "rgba(" + x + "," + y + "," + z + ",0.5)";
}

function mat_N_Prosireno(mat_N, mat_R) {
  let i;
  let NM = new Matrix(
    mat_N.columns + mat_R.columns,
    mat_N.rows + mat_R.columns
  );
  for (i = 0; i < mat_N.columns; i++) {
    for (j = 0; j < mat_N.rows; j++) {
      NM.set(i, j, mat_N.get(i, j));
    }
  }
  for (i = 0; i < mat_R.columns; i++) {
    for (j = 0; j < mat_R.rows; j++) {
      NM.set(i + mat_N.columns, j, mat_R.get(j, i));
      NM.set(j, i + mat_N.columns, mat_R.get(j, i));
    }
  }
  return NM;
}

function rad2dec(ugao_radiani) {
  return (ugao_radiani * 180) / Math.PI;
}
